import Swiper, { Navigation, FreeMode, Autoplay } from 'swiper'

export default function() {

    // Gallery block carousel
    Swiper.use([Autoplay, FreeMode, Navigation])

    const swipers = [];
    document.querySelectorAll('.swiper-block-desktop .swiper').forEach(function(el) {
        const swiper = new Swiper(el, {
            // Optional parameters
            loop: true,
            grabCursor: true,
            speed: 20000,
            autoplay: {
                delay: 0,
                // waitForTransition: false,
                disableOnInteraction: false,
            },
            freeMode: {
                enabled: true,
                sticky: true,
            },
            centeredSlides: true,
            slidesPerView: 5,
            // spaceBetween: 20,
            infinite: true
        });
        swipers.push(swiper);
    });

    document.querySelectorAll('.swiper-block-mobile .swiper').forEach(function(el) {
        const swiper = new Swiper(el, {
            // Optional parameters
            loop: true,
            infinite: true,
            navigation: {
                enabled: true,
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                disableOnInteraction: true
            }
        });
        swipers.push(swiper);
    });


}